'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pricesProvider = exports.PRICE_HANDLER_EVENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpDiffusionConnector = require('rp-diffusion-connector');

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

var _DiffusionServiceUtils = require('./utils/DiffusionServiceUtils');

var _PricesStateStore = require('./stores/PricesStateStore');

var _HorsesListStore = require('./stores/HorsesListStore');

var _PubSub2 = require('./utils/PubSub');

var _PubSub3 = _interopRequireDefault(_PubSub2);

var _DiffusionSubscriber = require('./utils/DiffusionSubscriber');

var _DiffusionSubscriber2 = _interopRequireDefault(_DiffusionSubscriber);

var _EVENTS = require('./constants/EVENTS');

var _EVENTS2 = _interopRequireDefault(_EVENTS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRICE_HANDLER_EVENTS = exports.PRICE_HANDLER_EVENTS = {
    PRICE_RECEIVED: 'PRICE_RECEIVED',
    PRICES_WILL_BE_UPDATED: 'PRICES_WILL_BE_UPDATED',
    PRICES_SETTINGS_CHANGED: 'PRICES_SETTINGS_CHANGED',
    RACE_INFO_RECEIVED: 'RACE_INFO_RECEIVED'
};

var PricesProvider = function (_PubSub) {
    _inherits(PricesProvider, _PubSub);

    function PricesProvider() {
        _classCallCheck(this, PricesProvider);

        var _this = _possibleConstructorReturn(this, (PricesProvider.__proto__ || Object.getPrototypeOf(PricesProvider)).call(this));

        _this.config = {
            session: {
                onDataFunction: _this.onDataReceive.bind(_this),
                onCallbackFunction: _this.onConnectionStatusChange.bind(_this)
            }
        };
        return _this;
    }

    _createClass(PricesProvider, [{
        key: 'init',
        value: function init(bookmakerName) {
            _PricesStateStore.pricesStateStore.setCurrentBookmaker(bookmakerName);
            if (_jsCookie2.default.get('customizeSettings')) {
                this.setPriceViewType();
            }
            this.session = new _rpDiffusionConnector2.default(this.config.session);
            this.subscriber = new _DiffusionSubscriber2.default(this.session);
            this.subscriber.run();
            this.bindEvents();
            _HorsesListStore.horsesListStore.updateHorsesData();
            // TODO: move it out of provider (JIRA: PC-4559)
            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmakerName);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _jquery2.default)(document).on(_EVENTS2.default.BOOKMAKER_CHANGED, this.onBookmakerChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicPricesUpdated.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onHorsesListChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
        }

        /* eslint-disable class-methods-use-this */

    }, {
        key: 'setPriceViewType',
        value: function setPriceViewType() {
            var showDecimal = JSON.parse(_jsCookie2.default.get('customizeSettings')).decimalOdds;
            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
            }
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(event, newBookmakerName) {
            var horsesList = _HorsesListStore.horsesListStore.getHorsesList();

            this.unsubscribeAll();
            _PricesStateStore.pricesStateStore.setCurrentBookmaker(newBookmakerName);
            this.publish(PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED);
            this.subscribeForPrices(horsesList, newBookmakerName);
        }
    }, {
        key: 'onDynamicPricesUpdated',
        value: function onDynamicPricesUpdated() {
            var newHorsesData = _HorsesListStore.horsesListStore.updateHorsesData();
            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

            this.subscribeForPrices(newHorsesData, bookmaker);
        }
    }, {
        key: 'onHorsesListChanged',
        value: function onHorsesListChanged() {
            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

            this.unsubscribeAll();
            _HorsesListStore.horsesListStore.updateHorsesData();
            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmaker);
        }
    }, {
        key: 'onUserSettingsChanged',
        value: function onUserSettingsChanged(event, userSettings) {
            var showDecimal = userSettings.decimalOdds;

            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
                this.publish(PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, { showDecimal: showDecimal });
            }
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.subscriber.unsubscribeAll();
        }
    }, {
        key: 'subscribeForPrices',
        value: function subscribeForPrices(horsesList, bookmaker) {
            if (!bookmaker) {
                return;
            }

            var topics = horsesList.filter(function (horseData) {
                return horseData;
            }).map(function (horseData) {
                var courseName = horseData.courseName,
                    raceTime = horseData.raceTime,
                    raceDate = horseData.raceDate,
                    horseName = horseData.horseName;

                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic({
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate,
                    horseName: horseName,
                    bookmaker: bookmaker
                });
                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate,
                    bookmaker: bookmaker
                });

                return [priceTopic, infoTopic];
            }).reduce(function (acum, value) {
                return acum.concat(value);
            }, []).filter(function (topic) {
                return topic;
            });

            this.subscriber.subscribe(topics);
        }
    }, {
        key: 'unsubscribeFromPrices',
        value: function unsubscribeFromPrices(horsesList, bookmaker) {
            var _this2 = this;

            horsesList.map(function (horseData) {
                return _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(_extends(horseData, { bookmaker: bookmaker }));
            }).filter(function (topic) {
                return topic;
            }).forEach(function (topic) {
                return _this2.session.unsubscribe({ topic: topic });
            });
        }
    }, {
        key: 'onDataReceive',
        value: function onDataReceive(WebClientMessage) {
            var topic = WebClientMessage.getTopic();

            if (topic.includes('#INFO')) {
                this.handleRaceInfo(WebClientMessage);
            } else {
                this.handleHorsePrice(WebClientMessage);
            }
        }
    }, {
        key: 'onConnectionStatusChange',
        value: function onConnectionStatusChange(isOpened) {
            if (isOpened) {
                this.subscriber.run();
            } else {
                this.subscriber.stop();
            }
        }
    }, {
        key: 'handleHorsePrice',
        value: function handleHorsePrice(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);

            this.publish(PRICE_HANDLER_EVENTS.PRICE_RECEIVED, renderConfig);
            (0, _jquery2.default)(document).trigger(_EVENTS2.default.PRICES_NEED_SORTING);
        }
    }, {
        key: 'handleRaceInfo',
        value: function handleRaceInfo(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

            _PricesStateStore.pricesStateStore.updateRaceInfo(renderConfig);
            this.publish(PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, renderConfig);
        }
    }]);

    return PricesProvider;
}(_PubSub3.default);
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)


var pricesProvider = exports.pricesProvider = new PricesProvider();


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/PricesProvider.js
// module id = 924
// module chunks = 0